
import { Users, Handshake } from "lucide-react";

export const Supporters = () => {
  const supporters = [
    {
      name: "Association pour la Démocratie",
      role: "Partenaire Institutionnel"
    },
    {
      name: "Collectif Citoyen pour l'Égalité",
      role: "Partenaire Associatif"
    },
    {
      name: "Union pour les Droits Civiques",
      role: "Partenaire Stratégique"
    }
  ];

  return (
    <section className="py-16 md:py-20 bg-background">
      <div className="container">
        <div className="text-center mb-8 md:mb-12">
          <div className="flex items-center justify-center gap-3 md:gap-4 mb-4 md:mb-6">
            <Handshake className="w-6 h-6 md:w-8 md:h-8 text-title" />
            <h2 className="text-2xl sm:text-3xl font-bold">Nos Soutiens</h2>
          </div>
          <p className="text-base md:text-lg text-body-light max-w-2xl mx-auto px-4 md:px-0">
            Nous sommes fiers de collaborer avec des organisations partageant nos valeurs et notre engagement pour une société plus juste.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 px-4 md:px-0">
          {supporters.map((supporter, index) => (
            <div 
              key={index}
              className="bg-white p-5 md:p-6 rounded-2xl shadow-md hover:shadow-lg transition-shadow"
            >
              <Users className="w-10 h-10 md:w-12 md:h-12 text-subtitle mb-3 md:mb-4" />
              <h3 className="text-lg md:text-xl font-bold mb-1 md:mb-2">{supporter.name}</h3>
              <p className="text-body-light text-sm md:text-base">{supporter.role}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
